import { render, staticRenderFns } from "./ScanCard.vue?vue&type=template&id=fdb56da0&scoped=true&"
import script from "./ScanCard.vue?vue&type=script&lang=js&"
export * from "./ScanCard.vue?vue&type=script&lang=js&"
import style0 from "./ScanCard.vue?vue&type=style&index=0&id=fdb56da0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../shared/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdb56da0",
  null
  
)

export default component.exports